document.addEventListener('click', function(event) {
  const button = event.target.closest(
    '.qg-qty-minus, .qg-qty-plus'
  );

  if (!button) return;

  const container = button.closest('.qg-quantity');
  if (!container) return;

  const input = container.querySelector('.qg-qty-input');
  if (!input) return;

  const quantity = parseInt(input.value, 10) || 1;

  if (button.classList.contains('qg-qty-plus')) {
    input.value = quantity + 1;
  } else {
    input.value = Math.max(1, quantity - 1);
  }

  input.dispatchEvent(new Event('change', {
    bubbles: true
  }));
});

document.addEventListener('click', async function(event) {
  const button = event.target.closest(
    '[data-quick-buy], [data-quickshop-slim]'
  );
  if (!button) return;

  const card = button.closest('[data-product-item-content]');
  if (!card) return;

  const input = card.querySelector('.qg-qty-input');
  if (!input) return;

  const quantity = parseInt(input.value, 10) || 1;
  if (quantity <= 1) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  button.disabled = true;

  try {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: quantity
          }]
        })
      }
    );

    if (!response.ok) {
      throw new Error('Ajout au panier impossible');
    }
const cartResponse = await fetch(
  window.Shopify.routes.root + 'cart.js'
);
const cart = await cartResponse.json();
document.querySelectorAll(
  '.site-header-cart--count'
).forEach(counter => {
  counter.textContent = cart.item_count;
 counter.classList.add('visible');
});
   button.disabled = false;
   document.dispatchEvent(new CustomEvent('cart:updated', {
  detail: {
    cart: await fetch(
      window.Shopify.routes.root + 'cart.js'
    ).then(r => r.json())
  }
}));

button.textContent = 'Ajouté au panier ✓';
setTimeout(() => {
  button.textContent = 'Ajouter au panier';
}, 2000);
  } catch (error) {
    alert('Impossible d’ajouter cette quantité au panier.');
    button.disabled = false;
  }
}, true);

